import apiClient from './client';

export interface Tag {
  id: number;
  name: string;
  color?: string;
  description?: string;
  created_at: string;
  updated_at: string;
}

export interface EntityTag {
  id: number;
  tag_id: number;
  entity_type: string;
  entity_id: number;
  tag?: Tag;
}

export const tagsApi = {
  getAll: async (): Promise<Tag[]> => {
    const response = await apiClient.get<{ success: boolean; data: Tag[] }>('/tags');
    return response.data.data;
  },
  getById: async (id: number): Promise<Tag> => {
    const response = await apiClient.get<{ success: boolean; data: Tag }>(`/tags/${id}`);
    return response.data.data;
  },
  getByEntity: async (entityType: string, entityId: number): Promise<Tag[]> => {
    const response = await apiClient.get<{ success: boolean; data: Tag[] }>(`/tags/entity/${entityType}/${entityId}`);
    return response.data.data;
  },
  create: async (tag: Partial<Tag>): Promise<Tag> => {
    const response = await apiClient.post<{ success: boolean; data: Tag }>('/tags', tag);
    return response.data.data;
  },
  update: async (id: number, tag: Partial<Tag>): Promise<Tag> => {
    const response = await apiClient.patch<{ success: boolean; data: Tag }>(`/tags/${id}`, tag);
    return response.data.data;
  },
  delete: async (id: number): Promise<void> => {
    await apiClient.delete(`/tags/${id}`);
  },
  addToEntity: async (entityType: string, entityId: number, tagId: number): Promise<void> => {
    await apiClient.post(`/tags/entity/${entityType}/${entityId}`, { tag_id: tagId });
  },
  removeFromEntity: async (entityType: string, entityId: number, tagId: number): Promise<void> => {
    await apiClient.delete(`/tags/entity/${entityType}/${entityId}/${tagId}`);
  },
  setTags: async (entityType: string, entityId: number, tagIds: number[]): Promise<void> => {
    await apiClient.post('/tags/set', {
      entity_type: entityType,
      entity_id: entityId,
      tag_ids: tagIds,
    });
  },
};
